//
import Model from "@/models/Model"

/**
 * @class
 */
export default class ACloseRectified extends Model {
  
  /**
   * @description
   */
  resource () {
    return "close_rectified"
  }
}